import type { Control, FieldErrors, UseFormSetValue } from 'react-hook-form';

import {
    SHIPPING_FIELD_MAX_LENGTH,
    type ShippingSchemaType,
} from '@/components/steps/ShippingAddressStep/shippingSchema';
import CountedInput from '@/components/ui/CountedInput';
import { useOptionalField } from '@/hooks/useOptionalField';
import { t } from '@/lib/utils';

type CompanyShippingFieldsProps = {
    control: Control<ShippingSchemaType>;
    errors: FieldErrors<ShippingSchemaType>;
    setValue: UseFormSetValue<ShippingSchemaType>;
    defaultShowRecipient?: boolean;
};

const CompanyShippingFields = ({
    control,
    errors,
    setValue,
    defaultShowRecipient = false,
}: CompanyShippingFieldsProps) => {
    const [showRecipient, toggleRecipient] = useOptionalField(setValue, 'addressee', defaultShowRecipient);

    return (
        <>
            <CountedInput
                required
                control={control}
                name='companyName'
                label={t('general.companyName')}
                error={errors?.companyName?.message}
                maxLength={SHIPPING_FIELD_MAX_LENGTH.companyName}
            />
            <p className='text-color-gray text-size-12 margin-bottom-15 margin-top-5'>
                {t('onboarding.shippingAddress.companyName.note')}
            </p>

            <span className='text-size-12 text-color-dark display-block margin-top-15'>{t('general.recipient')}</span>

            {showRecipient && (
                <CountedInput
                    control={control}
                    name='addressee'
                    placeholder={t('onboarding.shippingAddress.recipient.placeholder')}
                    maxLength={SHIPPING_FIELD_MAX_LENGTH.recipient}
                    className='margin-top-5'
                />
            )}

            <button
                type='button'
                className='btn btn-link btn-primary width-auto align-self-start padding-5'
                onClick={toggleRecipient}
            >
                <span className={`uikit-icon ${showRecipient ? 'icon-trash' : 'icon-plus'}`} />
                <span>{t(showRecipient ? 'general.removeRecipient' : 'general.addRecipient')}</span>
            </button>
            <hr className='margin-y-15' />
        </>
    );
};

export default CompanyShippingFields;
